import { useState, useEffect } from 'react';

// Активная подвкладка страницы, СОХРАНЯЕМАЯ между перезагрузками (F5).
// Раньше активная вкладка жила в useState(0) → при F5 сбрасывалась на первую
// («Статистика»). Этот хук — drop-in замена useState: тот же [value, setValue],
// но значение пишется в localStorage и восстанавливается при следующем заходе.
//   key — уникальный ключ страницы (напр. 'slots', 'loyalty').
//   defaultTab — значение по умолчанию (число-индекс или строка-ключ вкладки).
export default function usePersistedTab(key, defaultTab = 0) {
  const storageKey = `adm_tab_${key}`;
  const [tab, setTab] = useState(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      if (raw == null) return defaultTab;
      // строковые вкладки возвращаем как есть; числовые — коэрсим в число
      if (typeof defaultTab === 'number') {
        const n = Number(raw);
        return Number.isFinite(n) ? n : defaultTab;
      }
      return raw;
    } catch {
      return defaultTab;
    }
  });
  useEffect(() => {
    try { localStorage.setItem(storageKey, String(tab)); } catch { /* приватный режим/квота — молча */ }
  }, [storageKey, tab]);
  return [tab, setTab];
}
